/*
 * Location picker component specific for Adalia M&E.
 * This is a composite based on other components.
 */
import React from "react";
import { Mode } from "../common.jsx";
import Helpers from './helpers.jsx'

import TextField from "./text_field.jsx";
import GridLayout from "./grid_layout.jsx";
import { AdaliaMEMapGrid, AdaliaMEMap } from "./adalia_me_map_fields.jsx";
import { Button } from "../../bootstrap/index.jsx";
import { Adalicon, FaIcon } from "../../common/Icons.jsx";

export default class AdaliaMeLocation extends GridLayout {
  static get CATEGORY() {
    return "question";
  }

  static get TYPE() {
    return "adalia_me_location";
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'component_title_adalia_me_location'
    };
  }

  static icon() {
    return <i className="fa fa-map-marker"></i>;
  }

  static defaultContent(language) {
    const fieldName = "field_" + Helpers.randomString();

    let latitudeTranslations = TextField.defaultContentTranslations(language);
    latitudeTranslations[language] = {
      ...latitudeTranslations[language],
      label: I18n.t("field_default_latitude", { scope: "fe", locale: language }),
      description: "",
      placeholder: "",
    };

    let longitudeTranslations = TextField.defaultContentTranslations(language);
    longitudeTranslations[language] = {
      ...longitudeTranslations[language],
      label: I18n.t("field_default_longitude", { scope: "fe", locale: language }),
      description: "",
      placeholder: "",
    };

    return Object.assign(super.defaultContent(language), {
      name: fieldName + "_location",
      rows: [
        [
          {
            span: 1,
            component: Object.assign(AdaliaMELocationGrid.defaultContent(language), {
              deletable: false,
              sortable: false,
              rows: [
                [
                  {
                    span: 1,
                    component: Object.assign(TextField.defaultContent(language), {
                      name: fieldName + "_latitude",
                      deletable: false,
                      sortable: false,
                      translations: latitudeTranslations,
                    }),
                  },
                ],
                [
                  {
                    span: 1,
                    component: Object.assign(TextField.defaultContent(language), {
                      name: fieldName + "_longitude",
                      deletable: false,
                      sortable: false,
                      translations: longitudeTranslations,
                    }),
                  },
                ],
              ],
            }),
          },
          {
            span: 1,
            component: Object.assign(AdaliaMELocationMap.defaultContent(language), {
              name: fieldName,
            }),
          },
        ],
      ],
    });
  }

  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      mapVisible: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();

    if (typeof this.props.updateSettingsCallback == 'function') {
      let content = this.props.content;
      if (content.isNewComponent) {
        content.rows[0][0].component.rows.forEach((comp, i) => {
          content.rows[0][0].component.rows[i][0].component.isNewComponent = true;
        })
        content.rows[0][1].component.isNewComponent = true;
        this.props.updateSettingsCallback(content.id, content, true);
      }
    }
  }

  getMapVisible() {
    return this.state.mapVisible;
  }

  toggleMapVisible = () => {
    this.setState((prevState) => ({ mapVisible: !prevState.mapVisible }));
  };

  renderComponentCol(comp) {
    return comp.props.content.type != "adalia_me_location_map" || this.getMapVisible();
  }

  locationPickerInitialized = () => {
    if (this.props.mode == Mode.FILL) {
      ["latitude", "longitude"].forEach((l) => {
        const c = this.constructor.nestedComponents(this.props.content).find((c) => (c.name || "").match(`_${l}`));

        if (c) {
          const fc = this.createNewComponentInstance(c, { answers: this.props.answers, prefillAnswers: this.props.prefillAnswers });
          const ans = fc.getRawAnswer(this.context);

          // Clear field, if it has not been filled, as location picker defaults to 0
          if (!ans) {
            jQuery(this.refs.root).find(`[name*="${c.name}"]`).val("");
          }
        }
      });
    }
  };

  componentProps() {
    return { toggleMapVisible: this.toggleMapVisible, locationPickerInitialized: this.locationPickerInitialized };
  }

  renderSettings() {
  }

  beforeUpdateSettings(content) {
    content.label = this.getText('label');
  }
}

export class AdaliaMELocationGrid extends AdaliaMEMapGrid {
  static get TYPE() {
    return "adalia_me_location_grid";
  }

  constructor(props) {
    super(props);

    this.gridRef = React.createRef();
  }

  handleLocationClick = () => {
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const inputGrid = jQuery(this.gridRef.current);
        ["latitude", "longitude"].map((l) =>
          inputGrid
            .find(`[name*="${l}"]`)
            .val(coords[l])
            // change event triggers pin to move to correct position for location picker
            .trigger(jQuery.Event("change", { originalEvent: true }))
            // blur event sets the zoom for map
            .trigger("blur")
        );
      },
      () => alert("Error: Failed to retrieve location!")
    );
  };

  renderView() {
    return (
      <div ref={this.gridRef}>
        {super.renderView()}
        <div className="mt-2">
          {this.props.mode == Mode.FILL ? (
            <Button elemType="button" onClick={this.handleLocationClick}>
              <FaIcon type="map-marker" /> {I18n.t("use_my_location", { scope: "fe" })}
            </Button>
          ) : null}
          {this.props.toggleMapVisible ? (
            <Button elemType="button" className={this.props.mode == Mode.FILL ? "ml-1" : ""} onClick={this.props.toggleMapVisible}>
              <Adalicon type="location" /> {I18n.t("adalia_me_location_picker", { scope: "fe" })}
            </Button>
          ) : null}
        </div>
      </div>
    );
  }
}

export class AdaliaMELocationMap extends AdaliaMEMap {
  static get TYPE() {
    return "adalia_me_location_map";
  }

  static get PARENT_TYPE() {
    return "adalia_me_location";
  }

  locationPickerInitialized = () => {
    if (this.props.locationPickerInitialized) {
      this.props.locationPickerInitialized();
    }
  };

  locationChanged = (location) => {
    if (this.props.updateAnswerCallback) {
      ["latitude", "longitude"].forEach((l) => {
        this.props.updateAnswerCallback(this.fullFieldName().replace(/\](?=[^\]]*$)/, `_${l}]`), location[l]);
      });
    }
  };

  renderAfterMap() {
    return <p className="description">{I18n.t("adalia_me_location_map_hint", { scope: "fe", locale: this.props.language })}</p>;
  }

  getFillModeOptions(inputGrid) {
    return {
      ...super.getFillModeOptions(),
      inputBinding: {
        latitudeInput: inputGrid.find('[name*="latitude"]'),
        longitudeInput: inputGrid.find('[name*="longitude"]'),
      },
    };
  }

  getLocationArr(inputGrid) {
    return ["latitude", "longitude"].map((l) => inputGrid.find(`[name*="${l}"]`).val()).filter((v) => v);
  }

  getInitialLocation(inputGrid) {
    const [lat = "0.0", long = "0.0"] = this.getLocationArr(inputGrid);
    return { latitude: lat, longitude: long };
  }

  initInputEvents(inputGrid, mapContainer) {
    // Update map when location fields are changed
    inputGrid.on("blur", "input", () => {
      let mapContext = mapContainer.locationpicker("map");
      mapContext.map.setZoom(15);
    });

    inputGrid.on("blur, focus", "input", (e) => {
      // Trigger change event to update pin location when answers have changed outside of the component.
      jQuery(e.target).trigger(jQuery.Event("change", { originalEvent: true }));
    });
  }
}
